module.exports = __webpack_public_path__ + "da688d84dae4955faeb20f6c8712626d.png";